export default function formatCurrency(value: number) {
  // Handle negative values, if necessary
  const isNegative = value < 0;
  value = Math.abs(value);

  // Suffixes for large numbers
  const suffixes = ['', 'K', 'M', 'B', 'T'];

  // Find the appropriate suffix based on the number size
  let suffixIndex = 0;
  while (value >= 1000 && suffixIndex < suffixes.length - 1) {
    value /= 1000;
    suffixIndex++;
  }

  // Format the number with 1 decimal point precision
  let formattedValue = value.toFixed(1);
  // Remove decimal part if it's 0
  if (parseFloat(formattedValue) % 1 === 0) {
    formattedValue = formattedValue.split('.')[0];
  }

  // Add the negative sign back if the number was negative
  if (isNegative) {
    formattedValue = `-${formattedValue}`;
  }

  // Add the suffix
  return formattedValue + suffixes[suffixIndex];
}

/**
 * Formats a deal amount value to display as 10k, 12k, 100k, 102k, 1M, 1.2M, 10M, 10.2M
 * @param value - The amount value to format
 * @returns Formatted string (e.g., "10k", "12k", "100k", "102k", "1M", "1.2M", "10M", "10.2M")
 */
export function formatDealAmount(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return 'N/A';
  }

  let numValue: number;
  if (typeof value === 'string') {
    const cleanedValue = value.replace(/[,\s$€£¥]/g, '');
    numValue = parseFloat(cleanedValue);
  } else {
    numValue = value;
  }

  if (numValue === 0) {
    return '0';
  }

  if (isNaN(numValue) || !isFinite(numValue)) {
    return 'N/A';
  }

  const isNegative = numValue < 0;
  const absValue = Math.abs(numValue);

  if (absValue >= 1_000_000) {
    const millions = absValue / 1_000_000;
    const formatted = millions % 1 === 0 ? millions.toString() : millions.toFixed(1);
    return `${isNegative ? '-' : ''}${formatted}M`;
  }

  if (absValue >= 1_000) {
    const thousands = Math.round(absValue / 1_000);
    return `${isNegative ? '-' : ''}${thousands}k`;
  }

  return `${isNegative ? '-' : ''}${Math.round(absValue)}`;
}
